import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

import { FavoriteData } from './types';
import { getMapsByFavoriteList } from './utils';

export function removeFavorite(channelId: number) {
  return queryClient.setQueryData<FavoriteData>(queryKeys.favoriteChannels, (data) => {
    if (!data) {
      return;
    }

    const { favoritePositions, favoriteList } = data;

    const position = favoritePositions.get(channelId);
    const newList = favoriteList.filter((_, index) => index !== position);

    const { dictionary, positions } = getMapsByFavoriteList(newList);

    return {
      favoriteDictionary: dictionary,
      favoriteList: newList,
      favoritePositions: positions,
    };
  });
}
